import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GamePhase } from '../../../interfaces/game-state.interface';
import { GameModeService } from '../../../_services/game-mode.service';
import { MiniGameService } from '../../../_services/mini-game.service';
import { GlobalService } from 'src/app/_services/global.service';

/**
 * Top-level "what kind of game?" picker — two big tiles.
 *  - Trivia → SUBJECT_PICK (existing quiz / mini-game flow)
 *  - Fun Games → FUN_GAMES_PICK (Bowling + future fun games)
 *
 * Honors `gameModeService.autoStartOnEntry` like the subject picker
 * did: when set, immediately enable the auto-cycle and start the
 * first mini-game so the calling-screen → game-mode flow doesn't
 * stop at a manual picker.
 */
@Component({
  selector: 'app-game-category-picker',
  templateUrl: './game-category-picker.component.html',
  styleUrls: ['./game-category-picker.component.scss']
})
export class GameCategoryPickerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';

  constructor(
    private gameModeService: GameModeService,
    private miniGameService: MiniGameService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    if (this.gameModeService.autoStartOnEntry) {
      this.gameModeService.autoStartOnEntry = false;
      this.miniGameService.enableAutoCycle();
      this.miniGameService.startNextAutoCycleGame();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  pickTrivia(): void {
    this.gameModeService.setPhase(GamePhase.SUBJECT_PICK);
  }

  pickFunGames(): void {
    this.gameModeService.setPhase(GamePhase.FUN_GAMES_PICK);
  }

  pickAcademic(): void {
    this.gameModeService.setPhase(GamePhase.ACADEMIC_SUBJECT_PICK);
  }

  goBack(): void {
    // Mirrors subject-picker — top-level back closes the game mode.
    this.gameModeService.closeGame();
  }
}
